export default {
  bind: function(el) {
    if (el) {
      el.addEventListener('click', () => {
        const target = el
        target.blur()
      }, true)
    }
  }
}
